import { Col } from 'antd';
import GoogleMapReact from 'google-map-react';
import React from 'react';
import { useMeasure } from 'react-use';

import { GOOGLE_MAP_3D_IMAGERY_SETTINGS } from 'constants/google-map';
import { LatLong } from 'types/asset';
import { AssetTypeId } from 'types/models/asset-type';
import Country from 'types/models/country';
import { latLngFitBounds } from 'utils/GeoMap/lat-long-fit-bounds';

import SimpleMapMarker from './SimpleMapMarker';

const { VITE_GOOGLE_MAP_API_KEY } = import.meta.env;

interface Props {
  assetTypeId?: AssetTypeId;
  country: Country;
  googleMapProps?: GoogleMapReact.Props;
  location?: LatLong;
  useBuiltInMapMarker?: boolean;
}

/**
 * A simple map to be used in details drawer, where only one MapMarker marks the location of the monitor or device or
 * sample point that we are looking at
 * */
function DrawerSimpleMap({
  assetTypeId,
  country,
  googleMapProps,
  location,
  useBuiltInMapMarker = true
}: Props): JSX.Element {
  const [ref, { width, height }] = useMeasure<HTMLDivElement>();

  const { center, zoom } = latLngFitBounds(
    location ? [location] : [],
    width,
    height,
    country
  );

  return (
    <Col ref={ref} style={{ height: '22rem', width: '100%' }}>
      {location ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: VITE_GOOGLE_MAP_API_KEY, version: 'quarterly'
          }}
          options={() => ({
            ...GOOGLE_MAP_3D_IMAGERY_SETTINGS,
            mapTypeId: 'hybrid',
            scaleControl: true
          })}
          center={center}
          zoom={zoom}
          {...googleMapProps}
        >
          {useBuiltInMapMarker && (
            <SimpleMapMarker
              lat={location[0]}
              lng={location[1]}
              assetTypeId={assetTypeId}
            />
          )}
        </GoogleMapReact>
      ) : (
        <div className="body-copy">
          Monitor location is not available now.
        </div>
      )}
    </Col>
  );
}

export default DrawerSimpleMap;
